export default "__VITE_ASSET__CXfli2sQ__"